// Effect Managers
import { put, select, call } from 'redux-saga/effects'

// Exports
export default function composeHandleRead ({
  actionCreators,
  url,
  token$,
  handleFetch,
}) {
  return function *handleRead (
    { url: maybeUrl, queryParams, id },
    { requestId = null, meta } = {},
  ) {
    const token = yield select(token$)

    const options = yield {
      url: maybeUrl || url,
      token,
      queryParams,
      id,
      method: 'GET',
      meta,
    }

    yield put(actionCreators.fetching({
      queryParams,
      id,
    }, {
      meta: { requestId },
    }))

    const result = yield call(handleFetch, options)
    const { bad, status, data, model, response } = result || {}

    if (bad) {
      yield put(actionCreators.failFetch({
        id,
        queryParams,
        response,
        status,
      }, {
        requestId,
      }))
    } else {
      yield put(actionCreators.fetched({
        id,
        queryParams,
        response,
        status,
      }))

      yield put(actionCreators.receive({
        id,
        queryParams,
        data,
      }, {
        meta: { requestId },
      }))
    }

    return { status, response, data, model, error: bad }
  }
}
